import { keyframes } from '@emotion/react';
import tw, { styled } from 'twin.macro';

export const ButtonWrapper = styled.span`
  ${tw`relative`};

  a {
    width: fit-content;
  }

  button, a {
    ${tw`flex items-center justify-center h-12 whitespace-nowrap overflow-ellipsis rounded px-4 py-2.5 gap-4 bg-white cursor-pointer`};
    font-family: Circular Std !important;
    border: 0.5px solid #007996;
    letter-spacing: 0.02em;
    line-height: 15.18px;
    font-weight: 450;
    font-size: 14px;
    color: #007996;

    &.show-chevron-icon span.button-text {
      ${tw`pr-4`};
    }

    span.button-text {
      font-family: Circular Std !important;
    }

    &.wrap-text span.button-text {
      ${tw`whitespace-pre-wrap`};
    }

    .chevron-icon, .close-icon {
      ${tw`p-1`};
  
      img {
        ${tw`w-3 h-3`};
      }
    }

    .chevron-icon {
      ${tw`absolute right-3`};
    }

    &.border-gray:not(:disabled) {
      border: 0.2px solid #a4a3a3;
    }
    
    &.borderless {
      ${tw`border-none`};
    }

    &.text-black:not(:disabled) {
      ${tw`text-black`};
    }

    &.error:not(:disabled) {
      ${tw`text-red-500 border-red-500`};
      border-width: 0.5
    }

    &.disabled,
    :disabled {
      ${tw`text-gray-400 border-gray-400 cursor-not-allowed bg-gray-100`};

      img {
        filter: grayscale(100%) brightness(100%) contrast(100%);
      }
    }

    &.transparent {
      ${tw`border-none bg-transparent`};
    }

    &.block {
      ${tw`w-full`};
    }

    &.text-left {
      ${tw`justify-start`};
    }

    &.icon:not(:disabled) {
      ${tw`p-0 w-10 h-10 border-none`};

      img {
        ${tw`w-full h-full`};
      }
    }

    &.link {
      ${tw`p-0 border-none bg-transparent underline gap-2`};
      line-height: 16.44px;
      font-weight: 500;
      font-size: 13px;

      &:not(:disabled) {
        color: #28879d;
      }
      
      img {
        ${tw`w-3`};
      }
    }
    
    &.filled:not(:disabled) {
      ${tw`bg-fplsBlue text-white border-none`};
    }

    &.grayed:not(:disabled) {
      ${tw`bg-gray-100 text-black border-none`};
    }

    &.text {
      ${tw`p-0 border-none bg-transparent`};

      &:not(:disabled) {
        line-height: 15.18px;
        font-weight: 450;
        font-size: 12px;
        color: #4f4f4f;
      }
    }

    img {
      ${tw`w-5 h-5`};
    }

    &.large {
      ${tw`h-14`};
    }
    
    &.small {
      ${tw`h-10`};
    }

    &.tiny {
      ${tw`h-7`};
      font-size: 12px;
    }
  }

  &:hover {
    .tooltip {
      display: block;
    }
  }
`;

export const InformationDiv = styled.div`
  ${tw`bg-white absolute p-4 text-center`}
  width: 220px;
  box-shadow: 0px 4px 25px rgba(196, 196, 196, 0.25);
  border-radius: 2px;
  border: 0.2px solid #0095ba;
  display: none;
  left: ${({ position }) => position === 'right' && '35px'};
  right: ${({ position }) => position === 'left' && '35px'};
  top: -10px;

  &:before {
    content: ' ';
    position: absolute;
    top: 10px;
    left: ${({ position }) => position === 'left' && '100%'};
    right: ${({ position }) => position === 'right' && '100%'};
    margin-top: 0px;
    border-width: 10px;
    border-style: solid;
    border-color: ${({ position }) =>
      position === 'left'
        ? 'transparent transparent transparent #0095ba'
        : 'transparent #0095ba transparent transparent'};
  }

  &:after {
    content: ' ';
    position: absolute;
    top: 11px;
    left: ${({ position }) => position === 'left' && '100%'};
    right: ${({ position }) => position === 'right' && '100%'};
    margin-top: 0px;
    border-width: 9px;
    border-style: solid;
    border-color: ${({ position }) =>
      position === 'left' ? 'transparent transparent transparent white' : 'transparent white transparent transparent'};
  }
`;

export const pulseBorder = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(0, 175, 191, 0.4);
  }
  50% {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  }
`;